import { IconButton } from '@mui/material';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import { useNavigate } from 'react-router-dom';

export default function BackButton() {
  const navigate = useNavigate();

  const back = () => navigate(-1);

  return (
    <IconButton edge="start" onClick={back}>
      <NavigateNextIcon
        sx={{ color: 'black' }}
      />
    </IconButton>
  );
}
